// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var $dot$dot = require("..");
var Block = require("bs-platform/lib/js/block.js");

function toResult(either) {
  return $dot$dot.foldEither((function (left) {
                return /* Error */Block.__(1, [left]);
              }), (function (right) {
                return /* Ok */Block.__(0, [right]);
              }), either);
}

function fromResult(result) {
  if (result.tag) {
    return $dot$dot.eitherLeft(result[0]);
  } else {
    return $dot$dot.eitherRight(result[0]);
  }
}

exports.toResult = toResult;
exports.fromResult = fromResult;
/* .. Not a pure module */



//////////////////
// WEBPACK FOOTER
// ../xod-func-tools/src/Either.bs.js
// module id = 358
// module chunks = 0